export const logo_wh = require('../assets/images/PlanNbuild_wh_wo_tag.png');
export const logo_blk = require('../assets/images/PlanNbuild_bl_wo_tag.png');
export const logo_wh_tag = require('../assets/images/PlanNbuild_wh_trim.png');
export const offering_img_1 = require('../assets/images/offering_img_1.jpg');
export const offering_img_2 = require('../assets/images/offering_img_2.png');
export const offering_img_3 = require('../assets/images/offering_img_3.png');
export const offering_img_4 = require('../assets/images/offering_img_4.png');
export const offering_img_5 = require('../assets/images/offering_img_5.png');
export const offering_img_6 = require('../assets/images/offering_img_6.png');
export const banner_video = require('../assets/images/plannbuild_banner.mp4');
export const catagory_bg = require('../assets/images/catagory_bg.png');
